export const statePillSx = {
  height: 22,
  borderRadius: '4px',
  fontSize: '11px',
  fontWeight: 600,
  '& .MuiChip-label': { px: 1 },
};

export const labelSx = {
  fontSize: '11px',
  fontWeight: 600,
  color: 'text.secondary',
  textTransform: 'uppercase' as const,
  letterSpacing: '0.04em',
  whiteSpace: 'nowrap' as const,
  flexShrink: 0,
};

export const valueSx = {
  fontSize: '12px',
  fontWeight: 500,
  whiteSpace: 'nowrap' as const,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  minWidth: 0,
  flexShrink: 1,
};

export const pillSx = (bg: string, text: string) => ({
  fontSize: '11px',
  fontWeight: 600,
  color: text,
  bgcolor: bg,
  borderRadius: '4px',
  px: 1,
  py: '3px',
  whiteSpace: 'nowrap' as const,
});

/** Canonical primary-action button for the User detail page. The summary-bar Save
 *  is the reference every other Save on the page is matched against, so this is
 *  re-exported from `userPanelStyles` rather than restated there. */
export const accentBtnSx = {
  bgcolor: 'v4.accent',
  py: '5px',
  px: '12px',
  textTransform: 'none' as const,
  fontWeight: 600,
  fontSize: '11px',
  color: 'common.white',
  whiteSpace: 'nowrap',
  boxShadow: 'none',
  // Stated explicitly because the shared `Button` atom hardcodes an 8px radius,
  // and this token is also applied to atom-based buttons elsewhere on the page.
  borderRadius: '4px',
  minWidth: 0,
  '&:hover': { bgcolor: 'v4.accentDark', boxShadow: 'none' },
  '&.Mui-disabled': { bgcolor: 'v4.borderDark', color: 'common.white', opacity: 0.7 },
};
